import React from 'react'
import { observable } from 'mobx'
import { format } from 'date-fns'

class SystemUptimeStore {
    constructor(store) {
        this.store = store
        this.setDates()
        this.getUptimes()
    }

    @observable request = {
        startTime: null,
        endTime: null,
    }

    tabels = [
        { value: 'api', name: 'API' },
        { value: 'surveys', name: 'Surveys' },
        { value: 'admin', name: 'Admin' },
    ]

    @observable upTime = {
        api: [],
        surveys: [],
        admin: [],
    }

    columns = [
        {
            key: 'service',
            name: 'Service',
            cellClass: 'cell',
        },
        {
            key: 'uptime',
            name: 'Uptime',
            dataTransform: (uptime) => (
                <p>
                    {`${uptime} `}
                    %
                </p>
            ),
        },
    ]

    @observable isResultFetched = false

    setDates = () => {
        const now = new Date()
        const lastSunday = new Date(now.setDate(now.getDate() - now.getDay()))
        const lastMonday = new Date(new Date(lastSunday).setDate(lastSunday.getDate() - 6))
        lastMonday.setHours(0, 0, 0)
        lastSunday.setHours(23, 59, 0)
        this.request.startTime = lastMonday
        this.request.endTime = lastSunday
    }

    getFormatedDates = (date) => format(new Date(date), 'yyyy-MM-dd hh:mm aa')

    handleChangeRequest = (value, date) => {
        if (date === 'start') {
            this.request.startTime = new Date(value)
        } else {
            this.request.endTime = new Date(value)
        }
    }

    mapData = (prometheusJson, duration) => {
        prometheusJson.data.result.forEach((result) => {
            const serviceName = result.metric.container
            const object = {
                service: serviceName,
                uptime: Math.round((result.values.length / duration) * 100),
            }

            if (serviceName === 'gateway') {
                this.upTime.admin.push(object)
                this.upTime.surveys.push(object)
                this.upTime.api.push(object)
            } else if (serviceName === 'external-api-service') {
                this.upTime.api.push(object)
            } else if (['mergefieldsapi', 'frontendapi-v3'].includes(serviceName)) {
                this.upTime.surveys.push(object)
            } else {
                this.upTime.admin.push(object)
            }
        })
        this.isResultFetched = true
    }

    getOverallUptime = (item) => {
        const allUptimes = []
        item.forEach((element) => {
            allUptimes.push(element.uptime)
        })
        return Math.min(...allUptimes)
    }

    getUptimes = async () => {
        const end = this.request.endTime.getTime()
        const start = this.request.startTime.getTime()
        try {
            const url = `https://prometheus.v3.production.hosting.explori.com:9090/api/v1/query_range?query=avg(kube_pod_container_status_running%7Bnamespace%3D~%22scala%7Cnodejs%22%7D)%20by%20(container)&start=${(start / 1000)}&end=${(end / 1000)}&step=60&_=1644572690886`
            const gatewayUrl = `/intranet/uptime?startTime=${this.request.startTime.toISOString()}&endTime=${this.request.endTime.toISOString()}`
            const [prometheusResult, upTimeResult] = await Promise.all(
                [
                    fetch(url),
                    this.store.http.get(gatewayUrl),
                ],
            )
            const prometheusJson = await prometheusResult.json()

            const duration = (
                (end - start) / 1000 / 60
            )
            this.upTime.admin.push({
                service: 'ColdFusion',
                uptime: Math.round(
                    ((duration * (upTimeResult.upTime / 100)) / duration) * 100,
                ),
            })

            this.mapData(prometheusJson, duration)
        } catch (e) {
            this.store.handleError({ body: `something went wrong: ${e.message}`, level: 'error' })
        }
    }
}

export default SystemUptimeStore
